module.exports = __webpack_public_path__ + "0eb2c9a98effc53c7fc4c7a1a991f38a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-7.png
// module id = 2097
// module chunks = 0